import React from 'react'
import IndexPage from '../index'

const IndexPageFr = () => {
    return <IndexPage languageCode="fr" />
}

export default IndexPageFr
